export default __webpack_public_path__ + "static/media/GAMEWORLD3.c7bdc8b6.png";